import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import { faqList } from '@/mocks/faq';

const featuredSlugs = [
  'basic-techniques-guide',
  'face-to-face-position',
  'female-experience-and-feelings',
  'communication-and-consent',
  'lubrication-essentials',
  'common-mistakes-and-corrections',
];

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const featuredArticles = articles.filter((a) => featuredSlugs.includes(a.slug));
  const recentArticles = articles
    .filter((a) => !featuredSlugs.includes(a.slug))
    .slice(0, 4);

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '乳交完全指南',
        url: 'https://zhuoyingcaiwu.cn/',
        description: '致力于为成年伴侣提供专业、负责任的亲密关系教育内容。',
      },
      {
        '@type': 'WebSite',
        name: '乳交完全指南',
        url: 'https://zhuoyingcaiwu.cn/',
        inLanguage: 'zh-CN',
      },
      {
        '@type': 'WebPage',
        '@id': 'https://zhuoyingcaiwu.cn/#webpage',
        url: 'https://zhuoyingcaiwu.cn/',
        name: '乳交完全指南 | 技巧、体位与注意事项',
        isPartOf: { '@id': 'https://zhuoyingcaiwu.cn/#website' },
      },
      {
        '@type': 'FAQPage',
        mainEntity: faqList.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20intimate%20atmosphere%20with%20soft%20silk%20fabric%20draped%20elegantly%2C%20candlelight%20glow%2C%20minimalist%20luxurious%20interior%2C%20romantic%20warm%20amber%20and%20cream%20tones%2C%20artistic%20abstract%20composition%2C%20gentle%20bokeh%20lights%2C%20sensual%20soft%20focus&width=1600&height=900&seq=home-hero&orientation=landscape"
            alt="乳交完全指南"
            className="absolute inset-0 w-full h-full object-cover"
            title="乳交完全指南 - 亲密关系教育"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 text-center">
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3 md:mb-4 max-w-2xl leading-tight">
              乳交完全指南
            </h1>
            <p className="text-sm md:text-base text-background-100/90 mb-2 max-w-xl leading-relaxed">
              技巧 · 体位 · 感受 · 注意事项
            </p>
            <p className="text-xs md:text-sm text-background-200/70 max-w-lg leading-relaxed">
              专为成年伴侣打造的专业亲密关系教育平台。探索乳交的方方面面，以负责任、尊重彼此的态度，提升亲密关系质量。
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center gap-3">
              <Link
                to="/category/techniques"
                className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-2.5 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i> 开始学习
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 bg-background-50/15 text-background-50 border border-background-50/30 px-6 py-2.5 rounded-md text-sm font-medium hover:bg-background-50/25 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line"></i> 关于我们
              </Link>
            </div>
          </div>
        </section>

        {/* Age Disclaimer */}
        <section className="bg-accent-100 border-b border-accent-200">
          <div className="px-4 md:px-6 py-3 text-center">
            <p className="text-xs md:text-sm text-accent-800">
              <i className="ri-alert-line mr-1"></i>
              <strong>内容声明：</strong>本站所有内容仅供18岁以上成年人参考，不构成医疗或心理咨询建议。
            </p>
          </div>
        </section>

        {/* Categories Section */}
        <section className="px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-2">
                内容分类
              </h2>
              <p className="text-sm text-foreground-500 max-w-md mx-auto">
                从四个维度系统地了解乳交，找到你感兴趣的内容
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="bg-background-50 rounded-lg p-5 border border-background-200 hover:border-primary-300 transition-all duration-200 group cursor-pointer"
                >
                  <div className={`w-10 h-10 rounded-lg bg-${cat.color}-100 flex items-center justify-center mb-3`}>
                    <i className={`${cat.icon} text-lg text-${cat.color}-600`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors duration-200">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {cat.description}
                  </p>
                  <span className="inline-flex items-center gap-1 mt-3 text-xs text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                    浏览分类 <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-2">
                精选文章
              </h2>
              <p className="text-sm text-foreground-500 max-w-md mx-auto">
                由专业团队精心编写，覆盖乳交各个核心话题
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {featuredArticles.map((article) => (
                <ArticleCard
                  key={article.slug}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  category={article.category}
                  readTime={article.readTime}
                  publishedAt={article.publishedAt}
                  imageUrl={article.imageUrl}
                />
              ))}
            </div>
          </div>
        </section>

        {/* More Articles */}
        <section className="px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-1">
                  更多文章
                </h2>
                <p className="text-sm text-foreground-500">继续探索更多深度内容</p>
              </div>
              <Link
                to="/category/techniques"
                className="text-sm text-primary-600 hover:text-primary-700 flex items-center gap-1 whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {recentArticles.map((article) => (
                <ArticleCard
                  key={article.slug}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  category={article.category}
                  readTime={article.readTime}
                  publishedAt={article.publishedAt}
                  imageUrl={article.imageUrl}
                />
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-2">
                常见问题
              </h2>
              <p className="text-sm text-foreground-500">关于乳交，你可能关心的常见疑问</p>
            </div>

            <div className="space-y-3">
              {faqList.map((faq, index) => (
                <details
                  key={index}
                  className="bg-background-50 rounded-lg border border-background-200 group"
                >
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer select-none">
                    <span className="text-sm font-medium text-foreground-800 pr-4">
                      {faq.question}
                    </span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200 flex-shrink-0"></i>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative w-full overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20abstract%20texture%20with%20soft%20silk%20waves%20in%20cream%20and%20amber%20tones%2C%20minimalist%20artistic%20composition%2C%20gentle%20gradient%20blur%2C%20romantic%20elegant%20atmosphere%2C%20fine%20art%20photography&width=1600&height=500&seq=home-cta&orientation=landscape"
            alt="了解更多"
            className="absolute inset-0 w-full h-full object-cover"
            title="探索更多内容"
          />
          <div className="absolute inset-0 bg-black/50"></div>
          <div className="relative z-10 px-4 md:px-6 py-12 md:py-16 text-center">
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-background-50 mb-3">
              准备好探索了吗？
            </h2>
            <p className="text-sm text-background-200 max-w-md mx-auto mb-6 leading-relaxed">
              从基础技巧开始，逐步深入了解乳交的方方面面，与伴侣一起打开新的亲密大门。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/techniques"
                className="inline-flex items-center gap-2 bg-background-50 text-foreground-900 px-6 py-2.5 rounded-md text-sm font-medium hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i> 浏览技巧分类
              </Link>
              <Link
                to="/category/safety"
                className="inline-flex items-center gap-2 bg-transparent text-background-50 border border-background-50/40 px-6 py-2.5 rounded-md text-sm font-medium hover:bg-background-50/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shield-check-line"></i> 安全第一
              </Link>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}